import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export interface AddedJobBid {
  token: string | null,
  jobId: string;
  userId: string;
  bid: string;
}

export const fetchAllBids = createAsyncThunk('bids/fetchAllBids', async (token: string | null) => {
  const response = await axios.get(`${process.env.REACT_APP_API_JOBS_URL}/bids/bids`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  return response.data.data;
});

export const addBid = createAsyncThunk(
  'bids/addBid',
  async (newBid: AddedJobBid) => {
    const { token, ...otherBidFeatures } = newBid;
    const response = await axios.post(`${process.env.REACT_APP_API_JOBS_URL}/bids/postbid`,
      otherBidFeatures,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data.data;
  },
);

export const fetchBidsByJobId = createAsyncThunk(
  'bids/fetchBidsByJobId',
  async ({ token, jobId }: { token: string | null, jobId: string }) => {
    if (!token || !jobId) {
      throw new Error('Token and Job ID are required.');
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_JOBS_URL}/bids/bids/${jobId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    // Transform the data to match the expected shape
    const transformedBids = response.data.data.map((bid: any) => ({
      jobId: bid.jobId,
      userId: bid.userId, // assuming userId is part of the bid data
      bid: bid.bid,
    }));

    return transformedBids; // Return the transformed bids array
  },
);
